import { formatHourAMPMFromStringInput } from "@/common/helpers/timeHelper";
import { useAgendaStyle } from "./styles";
import { mergeClasses } from "@fluentui/react-components";

export const CustomAgendaEventTemplate = (props: any) => {
	const { intl, dataContext } = props;
	const event = dataContext.event;
	const classes = useAgendaStyle();

	const formatDate = () => {
		if (event.isAllDay) {
			return intl.formatMessage({ id: "Agenda.AllDay" });
		}

		const startDate = getFormattedHour(event.start);
		const endDate = getFormattedHour(event.end);

		return `${startDate} - ${endDate}`;
	};

	const getFormattedHour = (eventDateObject: any) => {
		const convertFromUtc =
			eventDateObject.timeZone?.toLocaleLowerCase() === "utc";

		return formatHourAMPMFromStringInput(
			eventDateObject.dateTime,
			convertFromUtc
		)?.toLocaleUpperCase();
	};

	return (
		<>
			<div className={classes.customEvent}>
				<div className={classes.eventTimeContainer}>
					<div className={classes.eventTime}>{formatDate()}</div>
				</div>
				<div className={classes.eventDetailsContainer}>
					<div
						className={
							event.location?.displayName
								? classes.eventSubject
								: mergeClasses(classes.eventSubject, classes.centerVertically)
						}
						aria-label={event.subject}
					>
						{event.subject}
					</div>
					{event.location?.displayName && (
						<div className={classes.eventLocationContainer}>
							<div
								className={classes.eventLocation}
								aria-label={event.location.displayName}
							>
								{event.location.displayName}
							</div>
						</div>
					)}
				</div>
				<div></div>
			</div>
		</>
	);
};
